import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "form-check form-check-custom form-check-solid mb-2" }
const _hoisted_3 = { class: "form-check-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-check-input",
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.model]
      ]),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.input.label), 1)
    ])
  ]))
}